/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, OnInit } from '@angular/core';
import { PermitAll } from '@csx/security';

@Component({
  selector: 'lms-query-view',
  templateUrl: './query-view.component.html',
  styleUrls: ['./query-view.component.scss']
})
@PermitAll()
export class QueryViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
